import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';

const PublicRoutes = () => {
  var token = localStorage.getItem('access_token');

  return token !== null && token !== undefined && token !== '' ? (
    <Navigate replace to="/dashboard" />
  ) : (
    <Outlet />
  );
};

export default PublicRoutes;
